require('dotenv').config()

// TODO: Load from .env file
const config = {
  apiUrl: process.env.REACT_APP_API_URL ?? 'https://api.academiarafaeltoro.com.br',
  s3Url: 'https://arquivos.academiarafaeltoro.com.br/',
  checkoutUrl: process.env.REACT_APP_CHECKOUT_URL ?? 'https://www.academiarafaeltoro.com.br/checkout',
  trackingSampleCsvUrl: process.env.REACT_APP_TRACKING_SAMPLE_CSV_URL ?? 'https://arquivos.academiarafaeltoro.com.br.s3.amazonaws.com/tracking-sample-csv/rastreio.csv',
  hiddenMenu: ['scoreToroV2'],
  servicesUris: {
    auth: 'auth',
    user: 'users',
    aluno: 'students',
    curso: 'courses',
    cursos: 'courses',
    aula: 'lessons',
    questao: 'questions',
    desconto: 'discounts',
    afiliado: 'affiliates',
    telas: 'screens',
    pagamento: 'payments',
    pagamentos: 'payments',
    cashback: 'v1/services/cashback'
  },
  currencyConfig: {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  }
}

export default config
